import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { AnkorstoreBillingExport } from '@client/api-internal/data-contracts';

export interface BillingState {
  exportList: AnkorstoreBillingExport[];
  hasFinanceContact: boolean;
}

const initialState: BillingState = {
  exportList: [],
  hasFinanceContact: false,
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  getters,
  mutations,
};
